import React from 'react';
// nodejs library to set properties for components

class StarIcon extends React.Component {
  render() {
    return (
      <svg
        version="1.1"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className="star-icon"
      >
        <defs>
          <clipPath id="a">
            <path d="m0 24h24v-24h-24z" />
          </clipPath>
        </defs>
        <g transform="matrix(1.3333 0 0 -1.3333 0 32)">
          <g clipPath="url(#a)">
            <g transform="translate(7.4907 13.285)">
              <path d="m0 0 1.878-1.829c0.236-0.23 0.344-0.561 0.288-0.885l-0.443-2.584 2.321 1.22c0.291 0.155 0.64 0.155 0.931 0l2.32-1.22-0.442 2.584c-0.056 0.324 0.052 0.655 0.288 0.885l1.878 1.829-2.597 0.38c-0.325 0.047-0.606 0.252-0.752 0.546l-1.161 2.352-1.16-2.351c-0.146-0.295-0.427-0.5-0.752-0.547zm8.624-8.126c-0.16 0-0.32 0.038-0.466 0.115l-3.649 1.919-3.649-1.919c-0.336-0.179-0.745-0.15-1.053 0.076-0.308 0.224-0.462 0.602-0.398 0.977l0.696 4.063-2.951 2.875c-0.273 0.266-0.371 0.663-0.254 1.025 0.118 0.362 0.431 0.626 0.807 0.681l4.081 0.597 1.824 3.696c0.339 0.683 1.456 0.684 1.794 1e-3l1.825-3.697 4.081-0.597c0.377-0.055 0.689-0.319 0.807-0.681 0.117-0.362 0.019-0.759-0.254-1.025l-2.952-2.875 0.696-4.063c0.064-0.375-0.09-0.753-0.398-0.978-0.174-0.126-0.38-0.19-0.587-0.19" />
            </g>
            <g transform="translate(12,22.063)">
              <path d="m0 0c-5.549 0-10.063-4.514-10.063-10.063s4.514-10.063 10.063-10.063 10.063 4.514 10.063 10.063-4.514 10.063-10.063 10.063m0-22.126c-6.651 0-12.063 5.412-12.063 12.063s5.412 12.063 12.063 12.063 12.063-5.412 12.063-12.063-5.412-12.063-12.063-12.063" />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default StarIcon;
